import { render, staticRenderFns } from "./ModeratorTasksTable.vue?vue&type=template&id=6c6d61d1&scoped=true&"
import script from "./ModeratorTasksTable.vue?vue&type=script&lang=js&"
export * from "./ModeratorTasksTable.vue?vue&type=script&lang=js&"
import style0 from "./ModeratorTasksTable.vue?vue&type=style&index=0&id=6c6d61d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6d61d1",
  null
  
)

export default component.exports